import React from 'react';
import UtilsProfile from '../../utils/Profile';
import Utils from '../../utils/Utils';
import { 
    profileSettingsHandler, 
    profileHandler, 
    logoutHandler, 
    aboutHandler,
    refreshSessionHandler,
    mySubscriptionsHandler,
    seeProfilesHandler 
} from './utils';
import { CONFIG_TYPES } from './configTypes';
import AvatarImages from './components/AvatarImages/AvatarImages';
import Images from './components/Image/Image';

const CONFIG_BUTTON_SUFFIX = '_BUTTON';

export const CONFIG_BUTTON_TYPES = {
    PROFILE_SETTINGS: `${CONFIG_TYPES.PROFILE_SETTINGS}${CONFIG_BUTTON_SUFFIX}`,
    ABOUT: `${CONFIG_TYPES.ABOUT}${CONFIG_BUTTON_SUFFIX}`,
    REFRESH_SESSION: `${CONFIG_TYPES.REFRESH_SESSION}${CONFIG_BUTTON_SUFFIX}`,
    LOGOUT: `${CONFIG_TYPES.LOGOUT}${CONFIG_BUTTON_SUFFIX}`,
    MY_SUBSCRIPTIONS: `${CONFIG_TYPES.MY_SUBSCRIPTIONS}${CONFIG_BUTTON_SUFFIX}`,
    SEE_PROFILES: `${CONFIG_TYPES.SEE_PROFILES}${CONFIG_BUTTON_SUFFIX}`
};


const configButtons = {
    [CONFIG_BUTTON_TYPES.PROFILE_SETTINGS]: {
        id: CONFIG_BUTTON_TYPES.PROFILE_SETTINGS,
        labelKey: 'stb_social_settings',
        onClick: profileSettingsHandler,
        img: () => <Images assetKey="MenuAvatar_MenuPrincipal_Imagen_Configuraciones" height={'16.6rem'} width={'20rem'}/>
    },
    [CONFIG_BUTTON_TYPES.ABOUT]: {
        id: CONFIG_BUTTON_TYPES.ABOUT,
        labelKey: 'about_card_header',
        onClick: aboutHandler
    },
    [CONFIG_BUTTON_TYPES.REFRESH_SESSION]: {
        id: CONFIG_BUTTON_TYPES.REFRESH_SESSION,
        labelKey: 'btn_session_refresh',
        onClick: refreshSessionHandler
    },
    [CONFIG_BUTTON_TYPES.LOGOUT]: {
        id: CONFIG_BUTTON_TYPES.LOGOUT,
        labelKey: 'MenuAvatar_MenuPrincipal_TextoBoton5',
        onClick: logoutHandler,
        img: () => <Images assetKey="MenuAvatar_MenuPrincipal_Imagen_CerrarSesion" height={'16.8rem'} width={'20rem'}/>
    },
    [CONFIG_BUTTON_TYPES.MY_SUBSCRIPTIONS]: {
        id: CONFIG_BUTTON_TYPES.MY_SUBSCRIPTIONS,
        labelKey: 'MenuAvatar_MenuPrincipal_TextoBoton3',
        onClick: mySubscriptionsHandler,
        img: () => <Images assetKey="MenuAvatar_MenuPrincipal_Imagen_Suscripciones" height={'14rem'} width={'20rem'}/>
    },
    [CONFIG_BUTTON_TYPES.SEE_PROFILES]: {
        id: CONFIG_BUTTON_TYPES.SEE_PROFILES,
        labelKey: 'MenuAvatar_MenuPrincipal_TextoBoton1',
        onClick: seeProfilesHandler,
        img: ({ avatarImages }) =>  <AvatarImages img={avatarImages} />
    }
};

export const getButtons = (state) => {
    const buttons = [];
    const { profile, user } = state;
    const isProfilesEnabled = UtilsProfile.isProfileEnable(user);
    const isEnableSessionRefresh = Utils.getRegionaliazedMetadata('config_session', '{"default":{"enable":false}}').enable;
    const isLogoutVisible = Utils.getApaMetadataKey('is_logout_visible', '{false}');
    const enableAbout = false

    if(isEnableSessionRefresh) buttons.push(configButtons[CONFIG_BUTTON_TYPES.REFRESH_SESSION]);

    // ADD SEE_PROFILES button if profiles are enabled
    if (isProfilesEnabled) buttons.push(configButtons[CONFIG_BUTTON_TYPES.SEE_PROFILES]);

    buttons.push(configButtons[CONFIG_BUTTON_TYPES.MY_SUBSCRIPTIONS]);

    buttons.push(configButtons[CONFIG_BUTTON_TYPES.PROFILE_SETTINGS]);

    if(enableAbout) buttons.push(configButtons[CONFIG_BUTTON_TYPES.ABOUT]);

    if(isLogoutVisible) buttons.push(configButtons[CONFIG_BUTTON_TYPES.LOGOUT]);

    return buttons;
}


// WEBPACK FOOTER //
// ./src/containers/config/configButtons.js